<template>
    <div class="box">
        <img class="img" src="@/assets/image8.png">
        <div class="message">
            <div class="title">Email</div>
            <div class="info">contact@amazeen.io</div>
        </div>
    </div>
</template>

<style scoped>
.box{
    display: flex;
    flex-direction: row;
}
.img{
    width: 39px;
    height: 39px;
}
.message{
    display: flex;
    flex-direction: column;
    padding-left: 16px;
}
.title{
    font-size: 14px;
    color: #fff;
    line-height: 18px;
    font-weight: 500;
}
.info{
    font-size: 12px;
    color: #fff;
    line-height: 18px;
    font-weight: 400;
}
</style>